import React from 'react';

import { Alert, CircularProgress, Stack } from '@mui/material';

import { useGetSupplierRoomsForInternalRoom } from '~/hooks/apis/accommodation/useGetSupplierRoomsForInternalRoom';

import SupplierRoomListElement from './SupplierRoomListElement';

interface Props {
  internalRoomId: string;
  isExpanded: boolean;
  showNameInTitle?: boolean;
}

export default function SupplierRoomsForInternalRoomList({ internalRoomId, isExpanded, showNameInTitle }: Props) {
  const { data, isLoading, error } = useGetSupplierRoomsForInternalRoom({
    internalRoomId,
    enabled: isExpanded,
  });

  if (isLoading) {
    return (
      <Stack direction="row" justifyContent="center" p={2}>
        <CircularProgress size={24} />
      </Stack>
    );
  }

  if (error) {
    return <Alert severity="error">Failed to load supplier rooms</Alert>;
  }

  return (
    <>
      {(data?.supplierRooms ?? []).map((supplierRoom) => (
        <SupplierRoomListElement key={supplierRoom.id} supplierRoom={supplierRoom} showNameInTitle={showNameInTitle} />
      ))}
    </>
  );
}
